import React from "react";
import { CircularProgress, Box } from "@src/components";

interface LoadingSpinnerProps {
    className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => {
    return (
        <Box
            className={className}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100vh"
        >
            <CircularProgress />
        </Box>
    );
};

export default LoadingSpinner;
